module.exports = __webpack_public_path__ + "static/media/bg-desk.970c44cd.svg";